import { useState, useEffect, useContext } from 'react'
import styles from './styles.module.css'
import { Input, Select } from '../../../components/ModalInputs'
import Button from '../../../components/Button'
import Table from '../../../components/Table'
import { StaffRosterContext } from '../../../utils/context'
import { useSelector } from 'react-redux'

const API_TAB = 'vacation'

// Данные для дропдаунов
const vacationTypes = [
  { name: '', value: '' },
  { name: 'Ежегодный основной', value: 'annual_main' },
  { name: 'Ежегодный дополнительный', value: 'annual_additional' },
  { name: 'Учебный', value: 'study' },
  { name: 'Без сохранения зарплаты', value: 'unpaid' },
  { name: 'По беременности и родам', value: 'maternity' },
  { name: 'По уходу за ребенком', value: 'childcare' },
  { name: 'Дополнительный за выслугу лет', value: 'seniority' }
]

export default function Vacation() {
  const { allForms, trackDeletion } = useContext(StaffRosterContext)
  const { values, setFieldValue } = allForms

  // Данные из API (Redux)
  const { personTabData } = useSelector(state => state.personnel)
  const { vacation: apiVacation } = personTabData || {}

  const [formData, setFormData] = useState({
    vacationType: '',
    periodFrom: '',
    periodTo: '',
    calendarDays: '',
    startDate: '',
    endDate: '',
    basis: ''
  })

  const [selectedRow, setSelectedRow] = useState(null)

  // Данные таблицы берем из Formik
  const tableData = values.vacation || []

  // Синхронизация API данных с Formik (только при первой загрузке)
  useEffect(() => {
    if (apiVacation && !tableData.length) {
      setFieldValue('vacation', apiVacation)
    }
  }, [apiVacation, tableData.length, setFieldValue])

  const handleFormChange = (e) => {
    const { name, value } = e.target
    setFormData(prev => ({ ...prev, [name]: value }))
  }

  const handleRowSelect = (id) => {
    setSelectedRow(selectedRow === id ? null : id)
  }

  const handleAddRow = () => {
    const newRow = {
      id: `new_${Date.now()}`,
      vacation_type: formData.vacationType,
      period_from: formData.periodFrom,
      period_to: formData.periodTo,
      calendar_days: formData.calendarDays,
      start_date: formData.startDate,
      end_date: formData.endDate,
      basis: formData.basis
    }
    // Сохраняем в Formik
    setFieldValue('vacation', [...tableData, newRow])
  }

  const handleDeleteRow = () => {
    if (selectedRow !== null) {
      const rowToDelete = tableData.find(row => (row.id || row.xp_key) === selectedRow)
      if (rowToDelete) {
        const pk = rowToDelete.xp_key || rowToDelete.id || rowToDelete.xp_fm_id
        if (pk && !String(pk).startsWith('new_')) {
          trackDeletion(API_TAB, pk)
        }
      }
      // Обновляем в Formik
      const updatedData = tableData.filter(row => (row.id || row.xp_key) !== selectedRow)
      setFieldValue('vacation', updatedData)
      setSelectedRow(null)
    }
  }

  const renderOptions = ({ name, value }) => (
    <option key={value || 'empty'} value={value}>{name}</option>
  )

  return (
    <div className={styles.tabWrapper}>
      {/* Форма */}
      <div className={styles.qualificationForm}>
        {/* Строка 1 */}
        <div className={styles.inputsRow}>
          <Select
            label="Вид отпуска"
            name="vacationType"
            value={formData.vacationType}
            onChange={handleFormChange}
          >
            {vacationTypes.map(renderOptions)}
          </Select>
          <Input
            label="Кол-во кал. дней"
            type="number"
            name="calendarDays"
            value={formData.calendarDays}
            onChange={handleFormChange}
          />
        </div>

        {/* Строка 2 */}
        <div className={styles.inputsRow}>
          <Input
            label="Период работы с"
            type="date"
            name="periodFrom"
            value={formData.periodFrom}
            onChange={handleFormChange}
          />
          <Input
            label="Период работы по"
            type="date"
            name="periodTo"
            value={formData.periodTo}
            onChange={handleFormChange}
          />
        </div>

        {/* Строка 3 */}
        <div className={styles.inputsRow}>
          <Input
            label="Дата начала"
            type="date"
            name="startDate"
            value={formData.startDate}
            onChange={handleFormChange}
          />
          <Input
            label="Дата окончания"
            type="date"
            name="endDate"
            value={formData.endDate}
            onChange={handleFormChange}
          />
        </div>

        {/* Строка 4 */}
        <div className={styles.inputsRow}>
          <Input
            label="Основание"
            name="basis"
            value={formData.basis}
            onChange={handleFormChange}
          />
          <div className={styles.qualificationButtonsInline}>
            <Button onClick={handleAddRow}>+ Добавить строку</Button>
            <Button mode="delete" onClick={handleDeleteRow}>× Удалить строку</Button>
          </div>
        </div>
      </div>

      {/* Таблица */}
      <div className={styles.qualificationTableSection}>
        <Table>
          <thead>
            <tr>
              <th>Вид отпуска</th>
              <th>Период с</th>
              <th>Период по</th>
              <th>Кол-во дней</th>
              <th>Дата начала</th>
              <th>Дата окончания</th>
              <th>Основание</th>
            </tr>
          </thead>
          <tbody>
            {tableData.length > 0 ? (
              tableData.map(row => {
                const rowId = row.id || row.xp_key
                return (
                  <tr
                    key={rowId}
                    onClick={() => handleRowSelect(rowId)}
                    className={selectedRow === rowId ? styles.selectedRow : ''}
                  >
                    <td>{row.vacation_type || row.vacationType}</td>
                    <td>{row.period_from || row.periodFrom}</td>
                    <td>{row.period_to || row.periodTo}</td>
                    <td>{row.calendar_days || row.calendarDays}</td>
                    <td>{row.start_date || row.startDate}</td>
                    <td>{row.end_date || row.endDate}</td>
                    <td>{row.basis}</td>
                  </tr>
                )
              })
            ) : (
              <tr>
                <td colSpan="7" className={styles.emptyTable}>
                  Нет данных об отпусках
                </td>
              </tr>
            )}
          </tbody>
        </Table>
      </div>
    </div>
  )
}
